import { Place, TypesenseEventDocument } from '@/types';

import { useGlobal } from '../global-store';

export const useBookButtonAction = (event: TypesenseEventDocument | undefined, place: Place | undefined) => {
  const { setBookEvent, setBookTab, openBook, setOpenBook, setDmnConfig } = useGlobal();

  return () => {
    if (!event) {
      return;
    }

    if (event.bookingUrl) {
      window.open(event.bookingUrl, '_blank');
      return;
    } else {
      setBookEvent(event);

      if (!event.tonic?.id || !event.tonic?.active) {
        setDmnConfig({
          venue: place?.apps?.designMyNight?.id,
          allowedTypes: event.designMyNight?.id,
          date: new Date(event.dates * 1000)?.toISOString(),
        });
        setBookTab('design-my-night');
      } else {
        setBookTab('tonic');
      }

      if (!openBook) {
        setOpenBook(true);
      }

      return;
    }
  };
};
